// @flow

import type {RenderableTreeNode} from '@markdoc/markdoc';

// TODO(mfix) import this directly from @markdoc/markdoc
export {Tag} from '@markdoc/markdoc';

// %checks is documented here: https://flow.org/en/docs/types/functions/#toc-predicate-functions
export function isMarkdocAstTag(
  tag: RenderableTreeNode | Array<RenderableTreeNode>,
): boolean %checks {
  return tag != null && typeof tag === 'object' && !Array.isArray(tag);
}
